export default __webpack_public_path__ + "assets/ea5c314b470a7d5bb18c79f24f4b6aa4.png";